import React from "react";
import downloadReport from "../../../Assets/Icons/download-report-icon.svg";
import uploadIcon from "../../../Assets/Icons/upload-icon.svg";
import appIcon from "../../../Assets/Icons/app-icon.svg";
import forYouImage from "../../../Assets/images/for-you-image.png";
import GetACallBackModal from "Pages/Home/Components/GetACallBackModal";
import UploadPrescriptionModal from "../Modal/UploadPrescriptionModal";
import { useNavigate } from "react-router-dom";

const UnipathForYou = ({from}) => {
  const navigate = useNavigate();

  return (
    <div className="container">
      <div className="row">
        <div className="col-12">
          <div className="for-you-wrapper">
            <div className="for-you-content">
              <div className="section-heading">
                <h2>Unipath For You</h2>
                <p>
                Unipath as your trusted partner in total health checkup, offering quick access to lab reports, easy prescription uploads, and prompt support when you need it.
                </p>
              </div>
              <ul className="for-you-listing">
                <li
                  onClick={() => navigate("/my-reports", {state:{from:from}})}
                  className="for-you-listing-item"
                >
                  <div className="for-you-tag cursor-pointer">
                    <i className="">
                      <img alt="" src={downloadReport} />
                    </i>
                    <h3>Download Report</h3>
                  </div>
                </li>

                <li className="for-you-listing-item">
                  <UploadPrescriptionModal>
                    <div className="for-you-tag cursor-pointer">
                      <i className="">
                        <img alt="" src={uploadIcon} />
                      </i>
                      <h3>Upload Prescription</h3>
                    </div>
                  </UploadPrescriptionModal>
                </li>

                {/* <li className="for-you-listing-item">
                  <div className="for-you-tag">
                    <i className="">
                      <img alt="" src={appIcon} />
                    </i>
                    <h3>How to use the App</h3>
                  </div>
                </li> */}

                <li className="for-you-listing-item">
                  <GetACallBackModal>
                    <div className="for-you-tag cursor-pointer">
                      <i className="">
                        <img alt="" src={appIcon} />
                      </i>
                      <h3>Get A Call Back</h3>
                    </div>
                  </GetACallBackModal>
                </li>
              </ul>
            </div>
            <figure className="for-you-image">
              <img alt="" src={forYouImage} />
            </figure>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnipathForYou;
